var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineUserCirlceAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9 10.92c0-1.96 1.6-3.56 3.56-3.56s3.56 1.6 3.56 3.56-1.6 3.56-3.56 3.56-3.56-1.6-3.56-3.56zm1.5.01c0 1.14.92 2.06 2.06 2.06 1.14 0 2.06-.92 2.06-2.06 0-1.14-.92-2.06-2.06-2.06-1.13 0-2.06.92-2.06 2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9 20.2c0-1.92-1.99-3.48-4.44-3.48s-4.44 1.56-4.44 3.48c0 .41-.34.75-.75.75s-.75-.34-.75-.75c0-2.74 2.66-4.98 5.94-4.98 3.28 0 5.94 2.23 5.94 4.98 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 12.5c0-5.65 4.6-10.25 10.25-10.25 1.39 0 2.73.27 3.99.8.36.15.54.55.42.92-.11.33-.16.68-.16 1.03 0 .59.16 1.17.47 1.67.16.28.37.53.61.74.87.79 2.16 1.04 3.17.68.37-.14.79.05.94.42.54 1.27.81 2.62.81 4 0 5.64-4.6 10.24-10.25 10.24S1.25 18.15 1.25 12.5zm1.5 0c0 4.83 3.93 8.75 8.75 8.75s8.75-3.92 8.75-8.75c0-.96-.16-1.91-.46-2.82a4.75 4.75 0 0 1-3.95-1.16c-.35-.3-.66-.67-.9-1.08a4.695 4.695 0 0 1-.61-3.23c-.91-.31-1.86-.46-2.83-.46-4.82 0-8.75 3.92-8.75 8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.83 8.52c-.35-.3-.66-.67-.9-1.08-.44-.72-.68-1.57-.68-2.44 0-.51.08-1.01.24-1.49.22-.68.6-1.31 1.11-1.82.9-.92 2.11-1.44 3.41-1.44 1.36 0 2.65.58 3.53 1.58A4.74 4.74 0 0 1 23.76 5c0 .38-.05.76-.15 1.12-.1.45-.29.92-.55 1.33a4.61 4.61 0 0 1-2.58 2.05c-.45.17-.95.25-1.48.25a4.7 4.7 0 0 1-3.17-1.23zm.84-5.79c-.35.36-.6.77-.75 1.24-.11.33-.16.68-.16 1.03 0 .59.16 1.17.47 1.67.16.28.37.53.61.74.87.79 2.16 1.04 3.17.68.76-.24 1.38-.74 1.78-1.41.18-.29.3-.6.37-.91.07-.26.1-.51.1-.77 0-.8-.3-1.57-.84-2.17A3.22 3.22 0 0 0 19 1.75c-.89 0-1.72.35-2.33.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.73c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.99a.749.749 0 1 1 0 1.5H17.5z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.51V3.52c0-.41.34-.75.75-.75s.75.34.75.75v2.99a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineUserCirlceAdd);
export default __webpack_public_path__ + "static/media/vuesax-outline-user-cirlce-add.c578f6e24f8897abcf5ef7887d95affb.svg";
export { ForwardRef as ReactComponent };